export default "__VITE_ASSET__CYNJJOmY__"